import {Link} from "react-router-dom";
export default function Journey(){
    return(
        <>
        <section className="our-journey-area time-line pt-120 pb-85 pt-md-60 pb-md-25 pt-xs-60 pb-xs-25">
            <div className="container">
                <div className="journey-box">
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-20">
                                <img className="img-fluid" src="assets/img/history/j-1.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2000</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-15">
                                <img className="img-fluid" src="assets/img/history/j-2.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2006</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-20">
                                <img className="img-fluid" src="assets/img/history/j-3.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2008</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-15">
                                <img className="img-fluid" src="assets/img/history/j-4.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2010</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-20">
                                <img className="img-fluid" src="assets/img/history/j-5.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2012</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-box row align-items-center">
                        <div className="col-lg-6">
                            <div className="left-content mb-30 pr-15">
                                <img className="img-fluid" src="assets/img/history/j-6.jpg" alt="Img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-content mb-30">
                                <h2>2014</h2>
                                <h4>Company Foundation</h4>
                                <p>The sontent provides fully integrated
                                    marketing services designed</p>
                                <Link className="read-more" to="/case-details">Case Study <i
                                        className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}